// apps/web/src/app/store/belumDisimpan.ts
/**
 * Whether anything on screen is not saved yet, for what must never happen over it: the idle
 * lock (auth/kunciDiamTab), a sign-in step the API asks for mid-session (auth/guard) and the
 * role check (auth/session's `isianBelumDisimpan`) wait while it holds, as the update prompt
 * does. It reads both counts the forms keep:
 *
 * - the ui store's `dirtyForms`: every form registered with the leave guard whose changes hold
 *   the lock (useJagaPerubahan; the dialogs through DialogIsian), and a figure being typed or
 *   saved on a screen that saves field by field (useIsianBerjalan);
 * - each field-by-field screen's check (useJagaPeriksa, `jumlahHilang`) that leaving now would
 *   lose what no save carries (a refused figure, a failed save), asked at this moment.
 *
 * Not a typed password alone (useJagaPerubahan's `tahanKunci: false`): it is no work worth an
 * unlocked device, and "Tampilkan" would show it to whoever comes by. Leaving its form still
 * asks (the leave guard's full count, `jumlahKotor`, keeps it), and the lock takes the page,
 * and the password, with it. When other work holds the lock past its limit instead, the
 * password is masked again and an initial one emptied (auth/diamTertahan); the work stays.
 *
 * No React here and relative imports only: auth/app.ts wires it from the launch path.
 */
import { jumlahHilang, useJaga } from './jaga'
import { useUi } from './ui'

export function adaBelumDisimpan(): boolean {
  return useUi.getState().dirtyForms > 0 || jumlahHilang(useJaga.getState()) > 0
}
